import ModalContent from "@lib/common/components/modals/ModalContent";
import ModalFooter from "@lib/common/components/modals/ModalFooter";
import DatasetMapping from "@lib/dataset/Mapping/DatasetMapping";
import type { ColumnMapping } from "@lib/dataset/Mapping/types";
import { hasBlockingUploadMappingItems } from "@lib/dataset/Mapping/uploadMappingValidation";
import { Button, List, Stack, Text, Tooltip } from "@mantine/core";
import { useMemo } from "react";

export default function MappingView({
  items,
  onChange,
  onComplete
}: {
  items: ColumnMapping[];
  onChange: (items: ColumnMapping[]) => void;
  onComplete: () => void;
}) {
  const disableButton = useMemo(() => {
    return hasBlockingUploadMappingItems(items);
  }, [items]);

  return (
    <>
      <ModalContent>
        <Stack gap={"xs"}>
          <Text>Please choose a type for each one of the columns that you want to include.</Text>
          <List>
            <List.Item>
              <Text c="dimmed" size={"sm"}>
                Variables: Decision variables affecting the result, optimized towards a preferable outcome.
              </Text>
            </List.Item>
            <List.Item>
              <Text c="dimmed" size={"sm"}>
                Results: Goals of the experiment.
              </Text>
            </List.Item>
          </List>
        </Stack>
        <DatasetMapping items={items} onChange={onChange} />
      </ModalContent>
      <ModalFooter>
        <Tooltip
          label={"Please ensure that all the columns that are enabled have a selected type."}
          disabled={!disableButton}
        >
          <Button variant="filled" onClick={onComplete} disabled={disableButton}>
            Continue
          </Button>
        </Tooltip>
      </ModalFooter>
    </>
  );
}
